import { badgeTheme } from './badge/badgeTheme';
import { chartIndicatorTheme } from './chartIndicator/chartIndicatorTheme';
import { indicatorTheme } from './indicator/indicatorTheme';

export const indicatorsThemes = {
  ...badgeTheme,
  ...chartIndicatorTheme,
  ...indicatorTheme,
};
